import React, { Dispatch, useState } from 'react';
import { Collapse, Container, Navbar, NavbarToggler, NavItem, NavLink } from 'reactstrap';
import { Link } from 'react-router-dom';
import './NavMenu.css';
import { useDispatch } from 'react-redux';
import { getSearchReports } from '../../store/actions';
import { ComplianceTaskListModel } from '../../store/models/complianceTaskListModel';


const NavMenu: React.FC = () => {
    const [isOpen, setIsOpen] = useState<boolean>(false)
    const dispatch: Dispatch<any> = useDispatch()

    const toggle = () => {
        setIsOpen(!isOpen)
    }


    const clearData = () => {
        sessionStorage.clear();
        dispatch(getSearchReports({} as ComplianceTaskListModel))

    }

    return (
        <header>
            <Navbar className="navbar-expand-sm navbar-toggleable-sm border-bottom box-shadow mb-3" light>
                <Container>
                    <NavbarToggler onClick={toggle} className="mr-2" />
                    <Collapse className="d-sm-inline-flex flex-sm-row-reverse" isOpen={isOpen} navbar>
                        <ul className="navbar-nav flex-grow">
                            <NavItem>
                                <NavLink tag={Link} className="text-dark" to="/" onClick={clearData}>Home</NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink tag={Link} className="text-dark" to="/search" onClick={clearData}>Search</NavLink>
                            </NavItem>
                        </ul>
                    </Collapse>
                </Container>
            </Navbar>
        </header>
    );
}


export default NavMenu
